module.exports = __webpack_public_path__ + "img/ic_teacher_kecheng.f2f211ce.jpg";